import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { useSnackbar } from "src/utils/useSnackbar";
import { getAllActionPlanKey } from "./useGetAllActionPlan";
import { getOneActionPlanKey } from "./useGetOneActionPlan";

export const deleteActionPlanKey = "deleteActionPlanKey" as const;

type Options = {
    actionPlanId: string;
};

export const useDeleteActionPlan = () => {
    const queryClient = useQueryClient();
    const snackbar = useSnackbar();
    const { t } = useTranslation();

    const mutation = useMutation({
        mutationKey: [deleteActionPlanKey],
        mutationFn: async (options: Options) => {
            const { actionPlanId } = options;

            const response = await loggedInApiCall.delete(`/api/action_plans/${actionPlanId}`);

            return response;
        },
        onSuccess: () => {
            // Invalidate related queries to refresh the UI
            queryClient.removeQueries([getOneActionPlanKey]);
            queryClient.refetchQueries([getAllActionPlanKey]);

            snackbar.forceClose();
            snackbar.setSnackbarProps({
                type: "success",
                message: t("actionPlan.snackbar.deleted_success", "Your action plan has been successfully deleted!"),
                forceAutoHideInMilisecond: 10000,
            });
        },
        onError: (error) => {
            snackbar.forceClose();
            snackbar.setSnackbarProps({
                type: "error",
                message: t(
                    "actionPlan.snackbar.deleted_error",
                    "An error occurred. Please try again or contact support.",
                ),
                forceAutoHideInMilisecond: 10000,
            });
        },
    });

    return mutation;
};
